<div class="w-full h-full flex flex-col gap-1 overflow-y-auto">
    <div class="w-full flex items-center justify-between">
        <button class="w-10 h-10 flex items-center justify-center hover:text-nside-orange-400"
            (click)="$event.preventDefault(); onBack();"
        >
            <lucide-icon [img]="icons.ArrowLeft" size="32"></lucide-icon>
        </button>
        <div class="flex items-center justify-center gap-2 text-nside-orange-400">
            <h2 class="oswald-font text-2xl">Case {{ this.currentCaseId }}</h2>
            <div class="relative flex items-center justify-center">
                <button 
                    data-tooltip-target="tooltip-student-info"
                    data-tooltip-placement="bottom"
                    class="flex items-center justify-center w-8 h-8 shrink-0"
                    (click)="$event.preventDefault(); handleOpenModal('student info');"
                >
                    <lucide-icon [img]="icons.FileText"></lucide-icon>
                </button>
            
                <div id="tooltip-student-info" 
                     role="tooltip"
                     class="absolute z-30 invisible inline-block whitespace-nowrap px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                    Student Info
                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </div>
        </div>
    </div>
    <div class="w-full h-full overflow-y-auto">
        <router-outlet></router-outlet>
    </div>
</div>

<student-info
    *ngIf="this.showStudentInfo && this.studentSSID"
    [studentData]="this.studentInfo"
    (onClose)="handleCloseModal('student info')"
></student-info>

<div *ngIf="loading">
    <spinner></spinner>
</div>